<template>
	<div class="personal-wrapper">
		<div class="home-wrapper">
			<div>
				<el-image class="headUrl" :src="data.avatar" fit="fill"></el-image>
			</div>
			<div class="usermsg">
				<div><span class="username">{{data.nickname}}</span><i class="iconfont" :class="{'icon-nanxing': data.sex == 1,'icon-female': data.sex == 2}"></i></div>
				<div v-if="data.certificationId == 2 || data.certificationId == 3">
					<div class="experience">
						<span>经营范围：</span>
					</div>
					<div class="experience">
						<span>地址：</span>
					</div>
				</div>
				<div v-else>
					<div class="job">
						<span v-if="data.companyName"><i class="iconfont icon-gongsi"></i>{{data.companyName}}</span>
						<span><i class="iconfont icon-gongwenbao-F"></i>{{data.profession}}</span>
					</div>
					<div class="experience">
						<span>工作方式：{{data.workingWay==0?'远程':'驻场'}}</span>
						<span>工作经验：{{data.workingExperience}}年</span>
					</div>
				</div>
				
				<!-- <div class="tag">
					<div>标签：</div>
					<div class="tag-item">软件开发</div>
					<div class="tag-item">软件开发</div>
				</div> -->
				<div class="edit-btn">
					<el-button type="warning" size="small" round @click="">咨询</el-button>
				</div>
			</div>
			<div class="btn">
				<span class="guanzhu-btn" @click="data.isFollow?cancleFollow():follow()"><i class="iconfont" :class="data.isFollow?'icon-31guanzhu1xuanzhong':'icon-31guanzhu1'"></i>{{data.isFollow?'取消关注':'关注'}}</span>
			</div>
			
			
		</div>
		<div class="content-wrapper">
			<div class="desc-wrapper">
				<div>
					<div class="desc">
						<div class="title">介绍</div>
						<div class="summary">{{data.summary}}</div>
					
					</div>
					<div class="anli-wrapper" v-if="list.length>0">
						<div class="title">项目案例</div>
						<div class="list-item" v-for="item in list" @click="todetail(item)">
							<div class="image-wrapper">
								<el-image :src="item.cover" fit="fill">
									
								</el-image>
								<div class="isPrivate">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="item-content">
								<div class="title">{{item.title}}</div>
								<div class="abstrc">{{item.summary}}</div>
								
							</div>
						</div>
					
					</div>
				</div>
			</div>
			<div class="sidebar">
				<div class="side-item">
					<div class="title">相似推荐 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="userlist.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
					<div class="user-item" v-for="(item,index) in userlist" 
					:style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}"
					 @click="toDetail(item.userId)">
						<div>
							<div class="head-image"><el-image :src="item.avatar" fit="fill"></el-image></div>
							<div class="user">
								<div class="name" style="-webkit-box-orient: vertical;">{{item.nickname}}</div>
								<div class="company" style="-webkit-box-orient: vertical;">{{item.companyName?item.companyName:'暂无'}}</div>
							</div>
						</div>
						<div class="user-desc" style="-webkit-box-orient: vertical;">
							<span>简介：</span>
							<span>{{item.summary}}</span>
						</div>
					</div>	
					
				</div>
				<div class="side-item">
					<div class="title">公众号</div>
					<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
					<div class="tips">关注微信公众号，订阅每周资讯</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			
			</div>
		</div>
	</div>
</template>

<script>
import { getAnliList,getUserInfo,getUserList,AnliApply } from '@/api/crowd/index'
import { userFollow,unfollow } from '@/api/personal/user'
import { toLogin } from '@/api/isLogin'
import { getIsTrial, getToken } from '@/utils/auth'
export default {
    data() {
      return {
		data:{},
		list:[],
		userlist:[],
		ischange: false,
		isToggle: true,
		page: 1
      };
    },
    methods: {
	  toggleChange(){
	  	if(this.userlist.length>5){
			this.ischange = true
			this.isToggle = !this.isToggle
			setTimeout(() => {
			  this.ischange = false;
			}, 500); 
		}
	  },
	  toDetail(id){
	  	this.$router.push({name:'expert-detail',params:{id:id}})
	  	this.getInfo(id)
		this.getList(id)
	  },
	  async cancleFollow(){
	  	const res = await unfollow({followedUserId: this.data.userId})
	  	if (res.code === 0) {
	  		this.$message.success('已取消关注')
	  		this.getInfo(this.data.userId)
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
      async getInfo(id){
      	const res = await getUserInfo(id)
      	if (res.code === 0) {
      		this.data = res.data
      	} else {
      	  this.$message.error(res.msg)
      	}
      },
	  async follow(){
		if(getToken()){
			const res = await userFollow({followedUserId:this.data.userId})
			if (res.code === 0) {
				this.$message.success('已成功关注该用户')
				this.getInfo(this.data.userId)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
	  },
	  async userList(){
	  	const res = await getUserList({page:this.page,limit:10})
	  	if (res.code === 0) {
	  		this.userlist = res.data.list
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  // 案例列表
	  async getList(id){
	  	const res = await getAnliList({page:1,limit:10,userId:id})
	  	if (res.code === 0) {
	  		this.list = res.data.list
	  		this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  todetail(item){
		  if(getToken()){
		  	if(item.isPrivate == 1){
				this.$confirm('保密案例访问需要提交申请，是否需要申请?', '提示', {
				  confirmButtonText: '是',
				  cancelButtonText: '否',
				  type: 'warning'
				}).then(async () => {
				  const res = await AnliApply({caseId:item.id})
				  if (res.code === 0) {
					this.$message.success('已提交申请，请等待...')
				  } else {
					this.$message.error(res.msg)
				  }
				}).catch(() => {
					
				});  
		  	}else{
				window.open(item.previewUrl)  
		  	}
		  }else{
		  	toLogin(this)
		  }
		  
	  }
    },
	mounted(){
		var id = this.$route.params.id
		this.getInfo(id)
		this.getList(id)
		this.userList()
		window.scrollTo({top:0})
	}
  }
</script>

<style lang="scss" scoped>
.personal-wrapper{
	background: #f5f5f5;
	margin-top: 80px;
	min-height: 100vh;
	padding-top: 5px;
	.home-wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 15px auto;
		background: #fff;
		border-radius: 10px;
		padding: 30px;
		box-sizing: border-box;
		&>div{
			display: inline-block;
			vertical-align: top;
			color: #949494;
			margin-right: 20px;
			.headUrl{
				width: 60px;
				height: 60px;
				border-radius: 50%;
			}
			
			&.usermsg{
				width: calc(100% - 320px);
				&>div{
					margin-bottom: 10px;
					font-size: 15px;
					.username{
						font-size: 24px;
						color: #313131;
						// font-weight: 800;
					}
					.icon-nanxing{
						color: #64A6FF;
						margin-left: 10px;
						font-size: 20px;
						vertical-align: middle;
					}
					.icon-female{
						color: #FF64C4;
						margin-left: 10px;
						font-size: 20px;
						vertical-align: middle;
					}
					.iconfont{
						margin-right: 10px;
					}
					
				}
				.job,.experience{
					span{
						margin-right: 20px;
					}
				}
				.tag{
					div{
						display: inline-block;
					}
					.tag-item{
						margin-right: 20px;
						font-size: 13px;
						color: #FF8632;
						background-color: #FFF2F2;
						padding: 2px 8px;
						border-radius: 3px;
					}
				}
			}
			.edit-btn{
				margin-top: 20px;
				.el-button--warning{
					background-color: #FF842E;
					width: 100px;
				}
			}
			
		}
		.btn{
			float: right;
			cursor: pointer;
			.guanzhu-btn{
				margin-right: 20px;
				font-size: 16px;
				display: inline-block;
				vertical-align: middle;
				cursor: pointer;
				.iconfont{
					margin-right: 5px;
					font-size: 18px;
				}
				.icon-31guanzhu1xuanzhong{
					color: #FF440E;
				}
			}
			
			.el-button--warning{
				background-color: #FF842E;
			}
		}
	}
	.desc{
		width: 100%;
		background: #fff;
		border-radius: 10px;
		padding: 30px;
		box-sizing: border-box;
		.title{
			font-size: 22px;
			font-weight: 800;
		}
		.summary{
			font-size: 15px;
			color: #45494F;
			margin: 8px 0;
		}
	}
	.anli-wrapper{
		width: 100%;
		background: #fff;
		border-radius: 10px;
		padding: 30px;
		margin-top: 20px;
		box-sizing: border-box;
		.title{
			font-size: 22px;
			font-weight: 800;
		}
		.list-item{
			margin-top: 15px;
			cursor: pointer;
			.image-wrapper{
				display: inline-block;
				position: relative;
				.el-image{
					width: 120px;
					height: 90px;
					border-radius: 5px;
				}
				.isPrivate{
					position: absolute;
					top: 0;
					right: 0;
					left: 0;
					width: 120px;
					height: 90px;
					border-radius: 5px;
					color: #fff;
					text-align: center;
					font-size: 24px;
					line-height: 90px;
					background-color: rgba(0, 0, 0, 0.56);
					z-index: 1;
				}
			}
			.item-content{
				display: inline-block;
				width: calc(100% - 150px);
				vertical-align: top;
				margin-left: 30px;
				.title,.abstrc{
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.title{
					font-size: 18px;
					font-weight: 800;
					color: #292929;
					margin: 5px 0;
					&:hover{
						opacity: .82;
					}
				}
				.abstrc{
					font-size: 16px;
					color: #596372;
				}
				.operation{
					font-size: 14px;
					color: #A3A7AC;
					margin-top: 8px;
					cursor: pointer;
					&>div{
						display: inline-block;
						margin-right: 20px;
					}
					.iconfont{
						margin-right: 3px;
					}
				}
			}
			
		}
		/deep/.el-image__error{
			height: 100px;
		}
	}
	.desc-wrapper{
		display: inline-block;
		width: calc(100% - 300px);
	}
	.content-wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 15px auto;
	}
	.sidebar{
		display: inline-block;
		vertical-align: top;
		.active-image{
			.el-image{
				width: 270px;
				margin: 0 0 30px 30px;
				
			}
		}
		.side-item{
			width: 270px;
			box-sizing: border-box;
			padding: 24px;
			margin: 0 0 30px 30px;
			border-radius: 15px;
			box-shadow: 0 0 15px rgba(0,0,0, .05);
			background-color: #fff;
			
			.qrcode{
				margin: 20px auto;
				width: 80%;
				display: block;
			}
			.user-item{
				margin-top: 15px;
				cursor: pointer;
			}
			.head-image{
				display: inline-block;
				margin-right: 10px;
				.el-image{
					width: 50px;
					height: 50px;
					border-radius: 50%;
				}
			}
			.user{
				display: inline-block;
				vertical-align: top;
				width: calc(100% - 60px);
				.name{
					font-size: 18px;
					font-weight: 800;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
				.company{
					color: #4B5D73;
					font-size: 14px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
			}
			.user-desc{
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
				font-size: 14px;
				span:last-child{
					color: #4B5D73;
				}
			}

			.title{
				font-size: 18px;
				font-weight: 800;
				color: #2B2B2B;
				margin-bottom: 15px;
			}
			.tips{
				font-size: 14px;
				color: #525254;
				text-align: center;
			}
			.btn{
				cursor: pointer;
				float: right;
				color: #AAAEB4;
				font-weight: 500;
				font-size: 14px;
				.el-icon-refresh-right{
					font-size: 20px;
					margin-right: 5px;
					vertical-align: bottom;
				}
			}
			.change-btn{
				.el-icon-refresh-right{
					transform:rotate(360deg);
					transition: all .5s;
				}
			}
			
		}
	}
}
</style>